// src/pages/Auditorias/components/HistoricoLista.js
import React from 'react';
import { formatarData, formatarDuracao } from '../utils/formatacao';

const MODO_LABEL = {
  completa: 'completa',
  atualizacao: 'atualização',
  continuar: 'retoma',
};

const HistoricoLista = ({ execucoes, onValidar }) => {
  if (!execucoes?.length) return <p className="aud-vazio">Sem execuções registadas.</p>;

  return (
    <table className="aud-tabela aud-tabela-compacta">
      <thead>
        <tr>
          <th>Data</th>
          <th>Modo</th>
          <th>Peças</th>
          <th>Duração</th>
          <th>Estado</th>
          <th aria-label="Validação" />
        </tr>
      </thead>
      <tbody>
        {execucoes.map((e) => (
          <tr key={e.id}>
            <td>{formatarData(e.criado_em)}</td>
            <td>{MODO_LABEL[e.modo] || e.modo}</td>
            <td>{e.ficheiros_avaliados || 0}</td>
            <td className="aud-sub">{formatarDuracao(e.duracao_seg)}</td>
            <td>
              <span className={`aud-badge aud-estado-${e.estado}`}>{e.estado}</span>
              {e.erro && <div className="aud-sub aud-sub-alerta" title={e.erro}>{e.erro.slice(0, 60)}</div>}
            </td>
            <td>
              {e.validacao === 'validada' ? (
                <span className="aud-sub" title={formatarData(e.validado_em)}>
                  validada por {e.validado_por}
                </span>
              ) : e.estado === 'concluida' && onValidar ? (
                <button type="button" className="aud-link" onClick={() => onValidar(e.id)}>
                  validar
                </button>
              ) : (
                <span className="aud-sub">—</span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default HistoricoLista;
